import { render, staticRenderFns } from "./public-list-comp-card-v2.vue?vue&type=template&id=a1b365ac&scoped=true&"
import script from "./public-list-comp-card-v2.vue?vue&type=script&lang=ts&"
export * from "./public-list-comp-card-v2.vue?vue&type=script&lang=ts&"
import style0 from "./public-list-comp-card-v2.vue?vue&type=style&index=0&id=a1b365ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b365ac",
  null
  
)

export default component.exports